import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {tap} from 'rxjs/operators';

import {LocalStorageService} from '../local-storage/local-storage.service';

import {authLogin, authLoginFail, authLoginSuccess, authLoginUsernamePassword, authLogout} from './auth.actions';
import {UserInfo} from 'angular-oauth2-oidc/types';
import {AesAuthService} from '../../../app/auth/services/aes-auth.service';
import {SystemAuditService} from '../system-audit/system-audit.service';
import {State, Store} from '@ngrx/store';
import {UserProfile} from './auth.models';
import { AclService } from '@aes/acl/acl.service';
import { authModuleConfig } from 'app/auth';
import { changePasswordReset } from "../../../app/auth/change-password/state-management/change-password.actions";

export const AUTH_KEY = 'AUTH';

@Injectable()
export class AuthEffects {
    login = createEffect(
        () =>
            this._actions$.pipe(
                ofType(authLogin),
                tap(() => {
                        this._aesAuthService.loadUserProfile()
                            .then(userProfile => {
                                this._aclService.canAbility(true);
                                this._store.dispatch(authLoginSuccess({userProfile: userProfile}));
                            });
                    }
                )
            ),
        {dispatch: false}
    );

    loginUsernameAndPassword = createEffect(
        () =>
            this._actions$.pipe(
                ofType(authLoginUsernamePassword),
                tap(({username, password}) => {
                        this._aesAuthService.login(username, password)
                            .then(userProfile => {
                                this.loginSuccess(userProfile);
                            }).catch(err => {
                                this._store.dispatch(authLoginFail({err}));
                            });
                    }
                )
            ),
        {dispatch: false}
    );

    logout = createEffect(
        () =>
            this._actions$.pipe(
                ofType(authLogout),
                tap(() => {
                    // send Logout Audit request to server before call _aesAuthService.logout()
                    // while the access token is still valid
                  this._aesAuthService.logout().then(() => {
                    this._localStorageService.setItem(AUTH_KEY, {
                      isAuthenticated: false
                    });
                    this._router.navigate([authModuleConfig.loginPageRoute]);
                  });
                  this._store.dispatch(changePasswordReset())

                    // this._systemAuditService.preLogout().subscribe(
                    //     res => {
                    //         this._aesAuthService.logout().then(() => {
                    //             this._localStorageService.setItem(AUTH_KEY, {
                    //                 isAuthenticated: false
                    //             });
                    //             this._router.navigate([authModuleConfig.loginPageRoute]);
                    //         });
                    //     }
                    // );

                })
            ),
        {dispatch: false}
    );

    constructor(
        private _actions$: Actions,
        private _localStorageService: LocalStorageService,
        private _systemAuditService: SystemAuditService,
        private _router: Router,
        private _aesAuthService: AesAuthService,
        private _store: Store<any>,
        private _aclService: AclService
    ) {
    }
    loginSuccess(userProfile: UserProfile): void {
        this._store.dispatch(authLoginSuccess({userProfile: userProfile}));
        this._systemAuditService.postLogin();
        this._router.navigate(['']);
    }
}
